/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react"; 
import { useParams } from "react-router-dom";
import axios from 'axios';

import Header from "../../components/includes/Header";
import HeaderTitle from "../../components/includes/HeaderTitle";

import { unescapeHtml,ChangeDateStringOnlyDate,isNull } from "../../components/common/Common";

import "../../css/style.css";

const QuestionView = () => {
  const { board_idx } = useParams();
  //공지사항 
  const [varBoardData,setBoardData] = useState({});

  //공지사항정보 읽어오기
  const getQuestionList = async () => {
    const sendData = {board_idx:board_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_question_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setBoardData(datas.results);
      }
    });
  }
  //최초실행부
  useEffect(() => {
    getQuestionList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="vh-container">
      <Header varGoToMain={true} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={'1:1문의 상세'}/>
        <div className="vh-content-body">
          <div className="bbs-details-wrap">
            <div className="bbs-details-head mb25">
              <div className="bbs-details-date">{ChangeDateStringOnlyDate(varBoardData.board_rdate)}</div>
              <div className="bbs-details-subject mb10">
                <p>{unescapeHtml(varBoardData.board_title)}</p>
              </div>
            </div>
            <div className="bbs-details-body">
              <label>문의 내용</label>
              <div className="bbs-details-text mb20">{unescapeHtml(varBoardData.board_comment)}</div>
              {isNull(varBoardData.board_answer)?null:
                <>
                  <label>답변 내용</label>
                  <div className="bbs-details-text mb20">{unescapeHtml(varBoardData.board_answer)}</div>
                </>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default QuestionView;